import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EmployeeReportingHistorySetup, loadAllStaff, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const ReportingToAddSinglePopup = ({ list, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const reportingManager = useSelector((state) => state.users.list);
  const { Option } = Select;

  useEffect(() => {
    dispatch(loadAllStaff({ status: "true" }));
  }, [dispatch]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await dispatch(EmployeeReportingHistorySetup({
        ...values,
        ReportingHistoryId:0,
        EmployeeId: id,
        DataStatus: 1,
      }));
      if (response.payload.message === "success") {
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      // console.error("Error adding reporting history:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} className="mb-4">
        Add New Reporting Manager
      </Button>
      <Modal
        title="Add Reporting Manager"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="addReportingManager"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Reporting Manager"
            name="ReportingToId"
            rules={[{ required: true, message: "Please select a reporting manager!" }]}
          >
            <Select 
              placeholder="Select reporting manager" 
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {reportingManager?.map((manager) => (
                <Option key={manager.EmployeeId} value={manager.EmployeeId}>
                  {manager.EmployeeName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item
            label="Effective To"
            name="EffectedTo"
            // rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ReportingToAddSinglePopup;